import { Link } from "react-router-dom";

export const COLUMNS = [
  {
    Header: "Name",
    Footer: "Name",
    accessor: "name",
    sticky: "left",
  },
  {
    Header: "Mobile",
    Footer: "Mobile",
    accessor: "mobile",
  },

  {
    Header: "Activity",
    Footer: "Activity",
    accessor: "activity",
  },
  {
    Header: "Reward Point",
    Footer: "Reward Point",
    accessor: "rewardpoint",
  },
  {
    Header: "Location",
    Footer: "Location",
    accessor: "location",
  },
  {
    Header: "Date",
    Footer: "Date",
    accessor: "transactionProcessedDate",
    sticky: "left",
    // Cell: ({ value }) => {
    // 	return format(new Date(value), "dd/MM/yyyy");
    // },
  },
  {
    Header: "Action",
    Footer: "Action",
    accessor: "action",
  },
];

export const SOBISCO_COLUMNS = [
  {
    Header: "Name",
    Footer: "Name",
    accessor: "name",
    sticky: "left",
  },
  {
    Header: "Mobile",
    Footer: "Mobile",
    accessor: "mobile",
  },
  {
    Header: "Transaction ID",
    Footer: "Transaction ID",
    accessor: "transactionId",
  },
  {
    Header: "Transaction Type",
    Footer: "Transaction Type",
    accessor: "transactionType",
  },
  {
    Header: "Earning",
    Footer: "Earning",
    accessor: "earning",
  },
  {
    Header: "Order Value",
    Footer: "Order Value",
    accessor: "netValue",
  },
  {
    Header: "Bill Link",
    Footer: "Bill Link",
    accessor: "billLink",
    Cell: ({ value }) => {
      if (!value) return "";
      return (
        <Link to={value}>
          <i className="fa-solid fa-download"></i>
        </Link>
      );
    },
  },
  {
    Header: "Date",
    Footer: "Date",
    accessor: "transactionProcessedDate",
    // Cell: ({ value }) => {
    // 	return format(new Date(value), "dd/MM/yyyy");
    // },
  },
  {
    Header: "Action",
    Footer: "Action",
    accessor: "action",
  },
];

export const FINODAYA_COLUMNS = [
  {
    Header: "Name",
    Footer: "Name",
    accessor: "name",
    sticky: "left",
  },
  {
    Header: "Email",
    Footer: "Email",
    accessor: "email",
  },
  {
    Header: "Mobile",
    Footer: "Mobile",
    accessor: "mobile",
  },
  {
    Header: "Description",
    Footer: "Description",
    accessor: "description",
  },
  {
    Header: "Action",
    Footer: "Action",
    accessor: "action",
  },
];
